/**
 * ⚠️ HAND-WRITTEN FILE - DO NOT DELETE! ⚠️
 *
 * Below-fold Last.fm list + featured projects.
 */

import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BuildIcon from '@mui/icons-material/Build';
import { Link } from '@tanstack/react-router';
import { RecentlyScrobbled } from '@/components/RecentlyScrobbled';
import { ProjectCard } from '@/components/ProjectCard';
import { ProjectModal } from '@/components/ProjectModal';
import { getFeaturedProjects } from '@/lib/projects';
import type { Project } from '@/types/project';

export function HomeWork() {
  const featuredProjects = getFeaturedProjects().slice(0, 4);
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Box sx={{ bgcolor: 'background.default', py: 10 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} sx={{ alignItems: 'stretch' }}>
          <Grid size={{ xs: 12, md: 4 }} sx={{ display: 'flex' }}>
            <Box sx={{ width: '100%', minHeight: { xs: 500, md: 'auto' } }}>
              <RecentlyScrobbled username="cdbattags" limit={10} />
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 8 }}>
            <Stack spacing={3}>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography variant="h3" component="h2" fontWeight="bold">
                    <BuildIcon sx={{ verticalAlign: 'middle', mr: 1, fontSize: 36 }} />
                    Featured Projects
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    className="mt-2"
                    sx={{ fontSize: '1.05rem' }}
                  >
                    Open source libraries, tools, and systems I&apos;ve built
                  </Typography>
                </Box>
                <Button
                  component={Link}
                  to="/projects"
                  variant="outlined"
                  size="large"
                  endIcon={<ArrowForwardIcon />}
                  sx={{ flexShrink: 0 }}
                >
                  View All
                </Button>
              </Stack>

              <Grid container spacing={3}>
                {featuredProjects.map((project) => (
                  <Grid size={{ xs: 12, sm: 6 }} key={project.id}>
                    <ProjectCard
                      project={project}
                      onLearnMore={(projectItem) => {
                        setSelectedProject(projectItem);
                        setModalOpen(true);
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </Grid>
        </Grid>
      </Container>

      <ProjectModal
        project={selectedProject}
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setSelectedProject(null);
        }}
      />
    </Box>
  );
}
